import {
  Box,
  BoxProps,
  Divider,
  IconButton,
  InputBase,
  InputBaseProps,
} from "@/common/styles/style";
import SearchIcon from "@mui/icons-material/Search";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import { styles } from "./style";
import { getRoleName, roleInfo } from "@/helpers/getUserInfo";
import { useAuth } from "@/hooks/useAuth";

interface SearchBoxProps extends BoxProps {
  type?: string;
  searchType?: string;
  inputBaseProps?: InputBaseProps;
  onSearch: (value: string) => void;
  handleAddButton?: (e: React.MouseEvent) => void;
}

export default function SearchBox({
  type,
  searchType,
  inputBaseProps,
  onSearch,
  handleAddButton,
  ...props
}: SearchBoxProps) {
  const { userRole } = useAuth();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(e.target.value);
  };
  const isAdmin = getRoleName(userRole) === roleInfo.admin;

  return (
    <Box sx={styles.paperSearch} {...props}>
      <InputBase
        sx={styles.searchArea}
        placeholder="Search"
        {...inputBaseProps}
        onChange={handleSearchChange}
      />
      <IconButton
        type="button"
        aria-label="search"
        sx={styles.searchAreaButton}
      >
        <SearchIcon />
      </IconButton>
      {isAdmin && searchType === "addPlusBtn" && (
        <>
          <Divider sx={styles.searchDivider} orientation="vertical" />
          <IconButton
            color="primary"
            aria-label="plus"
            sx={styles.searchAreaButton}
            onClick={handleAddButton}
          >
            <AddBoxOutlinedIcon />
          </IconButton>
        </>
      )}
    </Box>
  );
}
